import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Don't track admin routes
    if (location.pathname.startsWith('/admin')) {
      return;
    }

    // Track pageview on route change
    const trackPageview = async () => {
      try {
        const apiUrl = import.meta.env.PROD
          ? '/api/analytics/pageview'
          : 'http://localhost:3000/api/analytics/pageview';

        await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            page: location.pathname,
            referrer: document.referrer || 'Direct',
          }),
        });
      } catch (error) {
        // Silently fail - don't break the app if analytics fails
        console.debug('Analytics tracking failed:', error);
      }
    };

    trackPageview();
  }, [location.pathname]);
};

